import { Controller } from "@hotwired/stimulus"
import * as PDFObject from 'pdfobject';

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    if(PDFObject.supportsPDFs){
      $(this.element).append($('<div style="height: 100vh; border: none !important; overflow: hidden;" class="w-100" id="pdf-viewer"></div>'))
      PDFObject.embed(this.urlValue, "#pdf-viewer");

    } else {
      const div = $(`<div>The browser doesn\'t allow inline PDF, in order to view the PDF click <a href="${this.urlValue}">here</a></div>`)
      $(this.element).append(div)
    }
  }
}
